import React, { useReducer } from "react";
import axios from "axios";
import AuthContext from "./authContext";
import AuthReducer from "./authReducer";
import { Navigate } from "react-router-dom";
import ErrorLogger from "../../components/ErrorLogger";
import {
  USER_LOADED,
  AUTH_ERROR,
  SOCIAL_LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
} from "../types";
import setAuthToken from "../../functions/auth_header";
import  { getAppUrl } from "../../functions/getEnv";

const AuthState = (props) => {
  const initialState = {
    token: localStorage.getItem("token"),
    isAuthenticated: false,
    loading: true,
    user: null,
  };
  // Note: mongoose and User model are server-side only - removed from client
  const [state, dispatch] = useReducer(AuthReducer, initialState);

  /* const apiUrl =
    import.meta.env.VITE_SITE_URL || import.meta.env.MODE === "production"
      ? ``
      : "http://localhost:5000"; */

  const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);
  // const currDb = import.meta.env.DB_STRING; db string shouldnt be exposed to front end
  // console.log('DB:', currDb);
  // console.log('AuthState');
  // console.log('appUrl:', appUrl);

  // Refresh Access Token
  const refreshToken = async () => {
    if (localStorage.token) {
      setAuthToken(localStorage.token);
    }

    try {
      const res = await axios.get(`${appUrl}/auth/refresh`);
      dispatch({
        type: USER_LOADED,
        payload: res.data.user,
      });
    } catch (error) {
      dispatch({
        type: AUTH_ERROR,
      });
      console.error(error.message);
      ErrorLogger.logError(error, "AuthState.js");
    }
  };

  // Load User
  const loadUser = async () => {
    if (localStorage.token) {
      setAuthToken(localStorage.token);
    }

    try {
      const currURL = window.location.href;
      // console.log('currURL:', currURL);
      const currURL12Chars = currURL.slice(-12);
      // console.log('currURL12Chars:', currURL12Chars);
      const currURL8Chars = currURL.slice(-8);
      // console.log('currURL8Chars:', currURL8Chars);
      const currURL9Chars = currURL.slice(-9);
      // console.log('currURL9Chars:', currURL9Chars);      
      const currURL5Chars = currURL.slice(-5);
      // console.log('currURL5Chars:', currURL5Chars);


      let res;
      let userAccessToken;
      
      if (
        currURL5Chars === "3000/" || // This is for localhost:3000 deployments
        currURL12Chars === "/information" ||
        currURL8Chars === "/interest" ||
        currURL9Chars === "/register" ||
        currURL5Chars === ".org/"    // This is for enrollments.llac.org deployments, also flexhigh.org & learn4life.org
      ) {
        res = await axios.get(`${appUrl}/auth/webapp`);
        userAccessToken = res.data.accessTokens[0];
        // console.log('Access Token 1:',userAccessToken);
        setAuthToken(userAccessToken);
      } else if (
        currURL.includes("information?site=") &&/\w+/.test(currURL.split("information?site=")[1])
      )  {
        res = await axios.get(`${appUrl}/auth/webapp`);
        userAccessToken = res.data.accessTokens[0];
        // console.log('Access Token 2:',userAccessToken);
        setAuthToken(userAccessToken);
      } else {
        res = await axios.get(`${appUrl}/auth`);
        userAccessToken = res.data.accessTokens[0];
        // console.log('Access Token 3:',userAccessToken);
        setAuthToken(userAccessToken);
        
        //user = currently logged in user in dashboard.
        let user = res.data.name;
        let charterAssignments= res.data.charterAssignments;
        // console.log("hi",charterAssignments);
        if (user == "Enrollment_Webapp") {
          return <Navigate to="/admin-login" replace />;
        }
      }
      dispatch({
        type: USER_LOADED,
        payload: res.data,
      });
    } catch (error)  {
      dispatch({
        type: AUTH_ERROR,
      });
     // console.error(error.message);
      ErrorLogger.logError(error, "AuthState.js");
    }
  };

  // Social Login
  const socialLogin = async (token) => {
    console.log('socialLogin called with token:', token);
    try {
      // Save token to localStorage and state
      localStorage.setItem("token", token);
      setAuthToken(token);

      dispatch({
        type: SOCIAL_LOGIN_SUCCESS,
        payload: token,
      });
      console.log('Token saved to localStorage and axios headers');

      // Small delay to ensure token is set
      await new Promise(resolve => setTimeout(resolve, 100));

      await loadUser();
      console.log('loadUser completed');
    } catch (error) {
      console.error('socialLogin error:', error);
      dispatch({
        type: LOGIN_FAIL,
      });
      console.error(error.message);
      ErrorLogger.logError(error, "AuthState.js");
    }
  };

  // Logout / Clear Profile
  const logout = () => {
    dispatch({ type: LOGOUT });
  };

  return (
    <AuthContext.Provider
      value={{
        token: state.token,
        isAuthenticated: state.isAuthenticated,
        loading: state.loading,
        user: state.user,
        loadUser,
        socialLogin,
        logout,
        refreshToken,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthState;
